import React from 'react';
import styles from './HeroOverlay.css';

const HeroOverlay = (props) => {
  return <div className={styles.overlay}>{props.children}</div>;
};

export default HeroOverlay;
